import api from '../../utils/helpers/api'

type ResponType = {
  data: any
  meta: object
}
const uriCompany = 'company'
const uriApplicantByCompany = 'company-job-user-list'
const uploadPhotoProfile = 'company-upload-logo'
const companyMultipleDelete = 'company-multiple-delete'

const company = {
  uploadPhotoProfile: async (data: any) => {
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
      formData.append('_method', 'PATCH')
    }
    return (await api.post(`${uploadPhotoProfile}`, formData)) as Promise<ResponType>
  },
  getCompany: async (param: any) => {
    return (await api.get(uriCompany, {params: param})) as Promise<ResponType>
  },
  getCompanyHash: async (param: any) => {
    return (await api.get(`${uriCompany}-list-hash`, {params: param})) as Promise<ResponType>
  },
  showCompany: async (id: any) => {
    return (await api.get(`${uriCompany}/${id}`)) as Promise<ResponType>
  },
  registerCompany: async (data: any) => {
    //create form data for uploading file
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
    }
    return (await api.post(`${uriCompany}-register`, formData)) as Promise<ResponType>
  },
  applicantByCompany: async (param: any) => {
    return (await api.get(uriApplicantByCompany, {params: param})) as Promise<ResponType>
  },
  multipleDeleteCompany: async (data: any) => {
    return (await api.post(`${companyMultipleDelete}`, data)) as Promise<ResponType>
  },
}

export default company
